import React from 'react';

export const IconNoticeDelivery = ({
  width = 24,
  height = 24,
  color = '#4864FF',
  ...props
}: JSX.IntrinsicElements['svg']) => (
  <svg width={width} height={height} viewBox='0 0 24 24' fill='none' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2 5V17H3.33682C3.89855 15.8175 5.1038 15 6.5 15C7.8962 15 9.10145 15.8175 9.66318 17H13V7V5H2ZM15 7V3H0V19H3.03544C3.27806 20.6961 4.73676 22 6.5 22C8.26324 22 9.72194 20.6961 9.96456 19H13H15H15.0354C15.2781 20.6961 16.7368 22 18.5 22C20.2632 22 21.7219 20.6961 21.9646 19H24V11.5858L19.4142 7H15ZM15 9V17H15.3368C15.8985 15.8175 17.1038 15 18.5 15C19.8962 15 21.1015 15.8175 21.6632 17H22V12.4142L18.5858 9H15ZM8 18.5C8 17.6716 7.32843 17 6.5 17C5.67157 17 5 17.6716 5 18.5C5 19.3284 5.67157 20 6.5 20C7.32843 20 8 19.3284 8 18.5ZM17 18.5C17 19.3284 17.6716 20 18.5 20C19.3284 20 20 19.3284 20 18.5C20 17.6716 19.3284 17 18.5 17C17.6716 17 17 17.6716 17 18.5Z'
      fill={color}
    />
  </svg>
);
